export default __webpack_public_path__ + "static/media/slack.59f150a0.svg";